import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_CONVERSATTION_URL = `${API_URL}/api/v1/parent/conversation`;
export const READ_MSG_URL = `${API_URL}/api/v1/parent/read-message`;
export const MSG_COUNT_URL = `${API_URL}/api/v1/parent/message-count`;
export const GET_KID_CHAT_LIST = `${API_URL}/api/v1/parent/chat`;

// ?kidId=${dataOfKid.ID}&parentId=
export function getConversation(payload) {
  return axiosInstance({
    url: GET_CONVERSATTION_URL,
    method: "GET",
    params: payload,
  });
}

export function readMessages(payload) {
  return axiosInstance({
    url: READ_MSG_URL,
    method: "PUT",
    data: payload,
  });
}

export function messageCount(payload) {
  return axiosInstance({
    url: MSG_COUNT_URL,
    method: "GET",
    params: payload,
  });
}

export function getKidChatList(payload) {
  return axiosInstance({
    url: GET_KID_CHAT_LIST,
    method: "GET",
    params: payload,
  });
}
